.card { display: flex; flex-direction: column; gap: 12px; padding: 16px 24px; background: var(--paper); border: var(--border-panel); box-shadow: var(--shadow-panel); }
.header { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 12px 16px; }
.nav { display: flex; align-items: center; gap: 10px; }
.right { display: flex; flex-wrap: wrap; align-items: center; gap: 12px 20px; }
.arrow { display: inline-flex; flex: none; align-items: center; justify-content: center; width: 32px; height: 32px; }
.arrowBox { display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border: var(--border-control); }
.arrow[aria-disabled='true'] { opacity: 0.3; cursor: not-allowed; }
.title { margin: 0; font-family: var(--font-cond); font-size: 26px; font-weight: 800; letter-spacing: -1px; line-height: 1; white-space: nowrap; }
.eyebrow { font-family: var(--font-mono); font-size: 9px; letter-spacing: 1.2px; color: var(--text-secondary); white-space: nowrap; }
.thisWeek { height: 32px; padding: 0 10px; border: var(--border-control); font-family: var(--font-mono); font-size: 9px; letter-spacing: 1px; white-space: nowrap; }
.totals { margin: 0; font-family: var(--font-mono); font-size: 11px; letter-spacing: 0.6px; color: var(--text-secondary); white-space: nowrap; }
.totalValue { font-family: var(--font-cond); font-size: 20px; font-weight: 900; letter-spacing: 0; line-height: 1; color: var(--ink); }
.dayLine { color: var(--ink); }
.strip { display: flex; gap: 8px; transition: opacity 200ms var(--ease-out); }
/* The previous week's bars stay while the next week loads; faded, they read as loading rather than as its figures. */
.strip[data-placeholder='true'] { opacity: 0.5; }
.day { flex: 1 1 0; min-width: 0; display: flex; flex-direction: column; gap: 4px; padding: 0 0 4px; text-align: left; }
.day[aria-disabled='true'] { cursor: default; }
.day[data-today='true'] { background: var(--paper-2); }
/* Inset, so the selected edge never changes the column's height. */
.day[aria-pressed='true'] { box-shadow: inset 0 -2px 0 var(--ink); }
.well { display: flex; flex-direction: column; justify-content: flex-end; }
/* Full track height scaled from the baseline, so a metric or week change animates transform only. */
.bar { display: flex; flex-direction: column-reverse; gap: 1px; width: 100%; height: 100%; transform-origin: bottom; transition: transform 200ms var(--ease-out); }
.stub { display: block; width: 100%; height: 2px; background: var(--line); }
.segment { display: block; width: 100%; min-height: 1px; }
.icons { display: inline-flex; gap: 2px; color: var(--text-secondary); }
.formChip { display: inline-flex; align-items: center; gap: 5px; margin-left: 6px; padding: 3px 7px; vertical-align: middle; background: var(--paper-2); border: var(--border-hair); font-size: 9px; letter-spacing: 1px; color: var(--ink); }
.sportKey { display: flex; flex-wrap: wrap; align-items: center; gap: 8px 18px; margin: 0; padding: 4px 0 0; list-style: none; font-family: var(--font-mono); font-size: 9px; letter-spacing: 1px; color: var(--ink); }
.sportKey li { display: inline-flex; align-items: center; gap: 6px; }
.sportKey svg { color: var(--text-secondary); }
.keySwatch { flex: none; width: 10px; height: 10px; }
.stackOrder { letter-spacing: 0.8px; color: var(--text-secondary); }
/* Wraps so a value with both markers drops under the day name on narrow desktop columns instead of overflowing. */
.label { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 4px; font-family: var(--font-mono); font-size: 10px; }
.dayName { letter-spacing: 1px; color: var(--ink); }
.day[data-today='true'] .dayName { color: var(--hot); }
.day[aria-disabled='true'] .dayName { color: var(--text-secondary); }
.dayValue { color: var(--ink); }
.dayValue[data-zero='true'] { color: var(--text-secondary); }
.valueRow { display: inline-flex; align-items: center; gap: 3px; }
.noPower { flex: none; width: 10px; height: 10px; background: var(--amber); border: 1px solid var(--ink); }
.multi { font-size: 8px; letter-spacing: 1px; color: var(--hot); }
.form { margin: 0; font-family: var(--font-mono); font-size: 10px; color: var(--text-secondary); }
.formLabel { font-size: 9px; letter-spacing: 1px; }
.formValue { color: var(--ink); }
.formValue[data-positive='true'] { color: var(--green); }

@media (max-width: 639px) {
  .sportKey { display: none; }
  .card { gap: 10px; padding: 10px 4px; box-shadow: 4px 4px 0 var(--ink); }
  .header { flex-wrap: nowrap; gap: 0; }
  .arrow { width: 44px; height: 44px; }
  .arrowBox { width: 28px; height: 28px; }
  .middle { flex: 1; min-width: 0; display: flex; flex-direction: column; align-items: center; gap: 2px; }
  .titleRow { display: flex; align-items: center; gap: 6px; }
  .title { font-size: 20px; letter-spacing: -0.5px; }
  /* A 44px hit area around the 12px icon that doesn't grow the title row. */
  .back { display: inline-flex; align-items: center; justify-content: center; min-width: 44px; min-height: 44px; margin: -12px -14px; color: var(--text-secondary); }
  .totals { max-width: 100%; overflow: hidden; text-overflow: ellipsis; font-size: 9px; }
  .totalValue { font-size: 13px; }
  .toggleRow { padding: 0 6px; }
  .toggle { width: 100%; }
  /* Vertical scrolling stays with the browser; horizontal drags reach useSwipe instead of cancelling it. */
  .strip { gap: 0; touch-action: pan-y; }
  .day { padding: 4px 6px; }
  .label { flex-direction: column; justify-content: center; gap: 1px; }
  .dayName { font-size: 9px; }
  .form { text-align: center; font-size: 9px; }
  .formLabel { font-size: 8px; }
}
